<script>
  import Dash from '../symbols/Dash.svelte';

  export let value;
  export let lang = undefined;
</script>

<a href={value.link} class='accompanying-event'>
  <div class='accompanying-event-box' class:accompanying-event-no-hover={!value.link}>
    <div class='accompanying-event-box-content'>
      <div class='accompanying-event-box-content-label'>
        {value.label[lang]}
      </div>

      <div class='accompanying-event-box-content-place-and-date'>
        <div class='accompanying-event-box-content-place-and-date-place'>
          {value.place}
        </div>

        <div class='accompanying-event-box-content-place-and-date-date'>
          {value.from.date} {#if value.from.time} ({value.from.time}) {/if}

          {#if value.to.date}
            <Dash/> {value.to.date} {#if value.to.time} ({value.to.time}) {/if}
          {/if}
        </div>
      </div>
    </div>

    <div class='accompanying-event-box-icon'
      class:accompanying-event-box-icon-purple={value.color === 'purple'}
      class:accompanying-event-box-icon-dark-red={value.color === 'dark-red'}
      class:accompanying-event-box-icon-red={value.color === 'red'}
      class:accompanying-event-box-icon-orange={value.color === 'orange'}
      class:accompanying-event-box-icon-yellow={value.color === 'yellow'}
      class:accompanying-event-box-icon-light-green={value.color === 'light-green'}
      class:accompanying-event-box-icon-green={value.color === 'green'}
      class:accompanying-event-box-icon-dark-green={value.color === 'dark-green'}
      class:accompanying-event-box-icon-turquoise={value.color === 'turquoise'}
      class:accompanying-event-box-icon-dark-blue={value.color === 'dark-blue'}
      class:accompanying-event-box-icon-blue={value.color === 'blue'}
      class:accompanying-event-box-icon-light-blue={value.color === 'light-blue'}>

      <i class='fa-solid fa-{value.icon}'/>
    </div>
  </div>
</a>

<style>
  .accompanying-event {
    flex-grow: 1;

    width: 100%;

    text-decoration: none;

    color: inherit;
  }

  .accompanying-event-box {
    position: relative;

    display: flex;
    align-items: flex-end;
    gap: 15px;

    padding: 15px;

    border-radius: 5px;

    background: var(--grey-3);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .accompanying-event-box:not(.accompanying-event-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--grey-5);

    transform: scale(1.025);
  }

  .accompanying-event-box-content {
    display: flex;
    flex-direction: column;
    gap: 5px;

    width: calc(100% - 65px);
  }

  .accompanying-event-box-content-label {
    display: flex;
    justify-content: center;
    align-items: center;

    text-align: center;

    font-family: var(--font-secondary);
    font-size: 20px;

    line-height: 1.25;
  }

  .accompanying-event-box-content-place-and-date {
    display: flex;
    justify-content: space-between;

    font-size: 14px;
  }

  .accompanying-event-box-content-place-and-date-place {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    font-weight: 550;

    color: var(--tertiary);
  }

  .accompanying-event-box-content-place-and-date-date {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    color: var(--grey-7);
  }

  .accompanying-event-box-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    width: 50px;
    height: 50px;

    border-radius: 50%;

    font-size: 20px;

    color: var(--white);
  }

  .accompanying-event-box-icon-purple {
    background: var(--purple);
  }

  .accompanying-event-box-icon-dark-red {
    background: var(--dark-red);
  }

  .accompanying-event-box-icon-red {
    background: var(--red);
  }

  .accompanying-event-box-icon-orange {
    background: var(--orange);
  }

  .accompanying-event-box-icon-yellow {
    background: var(--yellow);
  }

  .accompanying-event-box-icon-light-green {
    background: var(--light-green);
  }

  .accompanying-event-box-icon-green {
    background: var(--green);
  }

  .accompanying-event-box-icon-dark-green {
    background: var(--dark-green);
  }

  .accompanying-event-box-icon-turquoise {
    background: var(--turquoise);
  }

  .accompanying-event-box-icon-dark-blue {
    background: var(--dark-blue);
  }

  .accompanying-event-box-icon-blue {
    background: var(--blue);
  }

  .accompanying-event-box-icon-light-blue {
    background: var(--light-blue);
  }

  :global(body.dark) .accompanying-event-box {
    background: var(--grey-7);
    color: var(--black);
  }

  :global(body.dark) .accompanying-event-box:not(.accompanying-event-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--grey-9);
  }

  :global(body.dark) .accompanying-event-box-content-place-and-date-date {
    color: var(--grey-5);
  }

  :global(body.dark) .accompanying-event-box-icon-purple {
    background: var(--purple-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-dark-red {
    background: var(--dark-red-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-red {
    background: var(--red-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-orange {
    background: var(--orange-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-yellow {
    background: var(--yellow-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-light-green {
    background: var(--light-green-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-green {
    background: var(--green-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-dark-green {
    background: var(--dark-green-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-turquoise {
    background: var(--turquoise-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-dark-blue {
    background: var(--dark-blue-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-blue {
    background: var(--blue-dark);
  }

  :global(body.dark) .accompanying-event-box-icon-light-blue {
    background: var(--light-blue-dark);
  }

  @media only screen and (max-width: 1400px) {
    .accompanying-event {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 950px) {
    .accompanying-event {
      width: 100%;
    }
  }

  @media only screen and (max-width: 500px) {
    .accompanying-event-box-content-label {
      width: calc(100% + 65px);
    }

    .accompanying-event-box-content-place-and-date {
      justify-content: center;
      flex-direction: column;

      height: 50px;
    }

    .accompanying-event-box-icon {
      position: absolute;

      bottom: 15px;
      right: 15px;
    }
  }
</style>
